import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '@/app/store';

export interface DashboardState {
  title: string;
}

const initialState: DashboardState = {
  title: '',
};

export const softTagSlice = createSlice({
  name: 'softTag',
  initialState,
  reducers: {
    setTitle: (state: DashboardState, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
  },
});

export const { setTitle } = softTagSlice.actions;

export const selectTitle = (state: RootState): string => state.softTag.title;

export default softTagSlice.reducer;
